<template>
  <div v-if="filteredEntries.length" class="grid-display">
    <div class="grid-title">{{title}}</div>
    <div class="flex-box">
        <div class="flex-entry" v-for="(character, index) in filteredEntries" :key="index">
            <Tile :character="character" />
        </div>
    </div>
  </div>
</template>

<script>
import Tile from "@/components/Tile.vue"
export default {
  name: 'GridDisplay',
  props: {
    title: String,
    entries: Array,
    searchText: String
  },
  components: {
    Tile
  },
  computed: {
    filteredEntries() {
        if(!this.searchText) return this.entries
        return this.entries.filter((character) => {
            return character.name.toLowerCase().includes(this.searchText) || this.akaString(character).toLowerCase().includes(this.searchText)
        })
    }
  },
  methods: {
    akaString(character) {
        return character.aka.join(', ')
    }
  }
}
</script>

<style scoped>
.grid-display {
    background-color: #39352a;
    margin: 5px;
    padding: 5px;
}
.grid-title {
    text-transform: capitalize;
    font-size: 32px;
    padding-left: 5px;
}
.flex-box {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
}

@media (max-width: 800px) {
    .flex-box {
        flex-direction: column;
    }
}

.flex-entry {
    position: relative;
    width: 23%;
    margin:1%;
}

@media (max-width: 800px) {
    .flex-entry {
        width: 48%;
    }
}
</style>